import React from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "../../hooks/useForm";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Modal } from "../../components/common/Modal";
import { FormActions } from "../../components/common/FormActions";
import { TextInput } from "../../components/common/TextInput";
import { TextArea } from "../../components/common/TextArea";
import { FileUploader } from "../../components/common/FileUploader";
import { createCategory } from "../../service/categoryService";

export default function CreateCategoryModal({ onClose }) {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const { values, setField, reset } = useForm({
    nameEn: "",
    nameAr: "",
    descriptionEn: "",
    descriptionAr: "",
    imageUrl: "",
    isListed: true,
  });

  const mutation = useMutation({
    mutationFn: createCategory,
    onSuccess: () => {
      qc.invalidateQueries(["categories"]);
      reset();
      onClose();
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    mutation.mutate({
      nameEn: values.nameEn,
      nameAr: values.nameAr,
      descriptionEn: values.descriptionEn,
      descriptionAr: values.descriptionAr,
      imageUrl: values.imageUrl,
      isListed: values.isListed,
    });
  };

  return (
    <Modal title={t("createCategory")} onClose={onClose}>
      <form onSubmit={handleSubmit} className="space-y-4">
        <TextInput
          label={t("English Name")}
          name="nameEn"
          value={values.nameEn}
          placeholder={t("English Name")}
          onChange={(e) => setField("nameEn", e.target.value)}
          required
        />
        <TextInput
          label={t("Arabic Name")}
          name="nameAr"
          value={values.nameAr}
          placeholder={t("Arabic Name")}
          onChange={(e) => setField("nameAr", e.target.value)}
          required
        />
        <TextArea
          label={t("English Description")}
          name="descriptionEn"
          value={values.descriptionEn}
          placeholder={t("English Description")}
          onChange={(e) => setField("descriptionEn", e.target.value)}
          rows={3}
        />
        <TextArea
          label={t("Arabic Description")}
          name="descriptionAr"
          value={values.descriptionAr}
          placeholder={t("Arabic Description")}
          onChange={(e) => setField("descriptionAr", e.target.value)}
          rows={3}
        />
        <FileUploader
          label={t("imageUrl")}
          onUploadComplete={(key) => setField("imageUrl", key)}
          previewEnabled={true}
          initialKey={values.imageUrl}
        />
        
        <div className="flex items-center space-x-3">
          <input
            type="checkbox"
            id="isListed"
            checked={values.isListed}
            onChange={(e) => setField("isListed", e.target.checked)}
            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
          />
          <label htmlFor="isListed" className="text-sm font-medium text-gray-700">
            {t("categoryVisibility")}
          </label>
          <span className="text-xs text-gray-500">
            {values.isListed ? t("visibleToCustomers") : t("hiddenFromCustomers")}
          </span>
        </div>
        
        <FormActions
          isLoading={mutation.isLoading}
          onCancel={onClose}
          submitLabel={t("create")}
        />
      </form>
    </Modal>
  );
}